var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.json)?_c('rounded-container',{attrs:{"variant":"dark"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("View JSON for "+_vm._s(_vm.objectName))]},proxy:true}],null,false,1560546887)},[_c('div',{staticClass:"p-3"},[_c('vue-json-pretty',{attrs:{"data":_vm.json,"deep":_vm.deep}})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }